import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { EntityService } from '../../../shared/services/entity.service';
import { AdminDocument } from '../../../models/admin-document';
import { ApiService } from '../../../shared/services/api/api.service';
import { firstValueFrom } from 'rxjs';
import { SharedDocument } from '../../../models/share/share';
import { MatchStemsService } from '../../../shared/services/match-stems.service';

@Component({
  selector: 'app-admin-doc-guest-view',
  templateUrl: './admin-doc-guest-view.component.html',
  styleUrls: ['./admin-doc-guest-view.component.scss']
})
export class AdminDocGuestViewComponent implements OnInit, OnDestroy {
  @ViewChild('pdfViewContainer') pdfView!: ElementRef;

  shareToken!: string;
  adminDocId!: string;
  adminDoc!: AdminDocument;
  time!: number;

  constructor(private route: ActivatedRoute,
              private entityService: EntityService,
              private apiService: ApiService,
              private matchStemsService: MatchStemsService,
  ) { }

  ngOnInit() {
    // To prevent bugs in case a user with a license opened a document in guest mode, then go back to the app.
    if (localStorage.getItem('api_token')) {
      localStorage.removeItem('api_token');
    }

    this.route.params.subscribe(async (params) => {
      this.adminDocId = params['adminDocId'];
      this.shareToken = params['shareToken'];
      const openSourceId = params['openSourceId'];
      if (this.adminDocId) {
        this.entityService.sendEntityId(this.adminDocId);
        this.time = (new Date()).getTime();
        let query = `${this.adminDocId}?open_source=web_app`;
        if (openSourceId) {
          query = `${this.adminDocId}?open_source=email&open_source_id=${openSourceId}`;
        }

        // Retrieving sharedDocument.
        const adminDoc = await this.getAdminDoc(query, this.shareToken);
        if (adminDoc) this.adminDoc = adminDoc;
        // Retrieving matchStems from share.
        const sharedDocument = await this.getSharedDocumentFromShareId(+openSourceId, this.shareToken);
        this.adminDoc.matchStems = sharedDocument?.matchStems;
        this.matchStemsService.matchStems.set(sharedDocument?.matchStems ?? null);

        // Updating observable values.
        this.entityService.sendDocument(this.adminDoc);

      }
    });
  }

  /** Method Retrieving admin doc from opensourceId and shareToken */
  getAdminDoc(query: string, shareToken: string): Promise<AdminDocument | undefined> {
    return firstValueFrom(this.apiService.adminDoc.getSharedAdminDoc(query, shareToken)).catch((e)=>{
      console.log(`error retrieving shared document - message : ${e}`);
      return undefined;
    });
  }

  /** Method Retrieving SharedDocument from shareId and shareToken */
  getSharedDocumentFromShareId(shareId: number, shareToken: string): Promise<SharedDocument | undefined> {
    return firstValueFrom(this.apiService.share.getSharedDocument(String(shareId), shareToken)).catch((e)=> {
      console.log(`error retrieving shared document from share id - message : ${e}`);
      return undefined;
    });
  }

  ngOnDestroy(): void {
    this.entityService.sendEntityId(null);
    this.entityService.sendDocument(null);
  }

}
